class TpsProductNew extends HTMLElement {
  constructor() {
    super();
    this.SlideFlickity = null;
    this.productVariants = window.productVariants || [];
    this.stickyObserver = null;
    this.stickyResizeObserver = null;
    this.stickyTracker = null;
    this.stickySentinel = null;
    this.stickyScrollHandler = null;
    this.stickyMediaQuery = null;
    this.stickyMediaHandler = null;
    this.cartLockNotice = null;
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.columns = this.dataset.columns;
    this.slider = this.querySelector('.tps-product__lists');
    this.form = this.querySelector('.tps-product-new__form form');
    this.submitButton = this.querySelector('.tps-product-new-form__submit');
    this.priceElement = this.querySelector('[data-product-price]');
    this.submitButtonBaseText = this.submitButton ? this.submitButton.textContent.trim() : '';
    
    this.currentVariant = this.productVariants.find(v => v.id == this.dataset.productId);
    this.initialPriceValue = this.currentVariant ? this.currentVariant.price : 0;
    
    this.initFormValidation();
    this.initBookletLockElements();
    this.initStickyAddToCart();
    this.updatePrice();
    this.updateSubmitButtonLabel();
    
    if (this.submitButton) {
      this.submitButton.addEventListener('click', (e) => this.tpsProductNewAddToCart(e));
    }

    if (this.slider) {
      this.initFlickity(this.columns);
    }

    const scriptEl = this.querySelector('#tps-product-variants-script');
    if (scriptEl) {
      scriptEl.remove();
    }
  }
  
  initFlickity(groupCells) {
    if (this.SlideFlickity) {
      this.SlideFlickity.destroy();
      this.SlideFlickity = null;
    }
    
    this.SlideFlickity = new Flickity(this.slider, {
      contain: true,
      percentPosition: true,
      groupCells: groupCells,
      cellAlign: 'left',
      prevNextButtons: false,
      pageDots: false,
      friction: 0.8,
      selectedAttraction: 0.2,
      freeScroll: false,
      adaptiveHeight: false,
      setGallerySize: false
    });
  }
  
  initFormValidation() {
    if (!this.form) return;

    const handleOptionEvent = (e) => {
      if (e.target.classList.contains('tps-product-new-form__option-input')) {
        this.handleGallerySwitch(e);
        this.updatePrice();
        this.updateSubmitButtonLabel();
        this.querySelectorAll('.tps-product-new__tooltip').forEach((tip) => {
          tip.style.display = 'none';
        });
      }
    };

    this.form.addEventListener('change', handleOptionEvent);
    this.form.addEventListener('input', handleOptionEvent);
    this.form.addEventListener('click', (e) => {
      if (!e.target.classList.contains('tps-product-new-form__option-input')) return;
      window.requestAnimationFrame(() => {
        handleOptionEvent(e);
      });
    });
    
  }

  initBookletLockElements() {
    this.cartLockNotice = this.querySelector('.tps-product-new__cart-lock-notice');
  }

  lockBookletAddToCart() {
    if (!this.submitButton) return;

    this.submitButton.disabled = true;
    this.submitButton.classList.add('tps-product-new-form__submit--disabled');
    if (this.cartLockNotice) {
      this.cartLockNotice.style.display = 'block';
    }
  }

  getFormTooltip() {
    let tooltip = this.querySelector('.tps-product-new__tooltip--form');
    if (tooltip) return tooltip;

    const formContainer = this.querySelector('.tps-product-new__form');
    const submitContainer = formContainer ? formContainer.querySelector('.tps-product-new-form__submit-container') : null;
    if (!formContainer || !submitContainer) return null;

    tooltip = document.createElement('div');
    tooltip.className = 'tps-product-new__tooltip tps-product-new__tooltip--form';
    tooltip.style.display = 'none';
    submitContainer.parentNode.insertBefore(tooltip, submitContainer);
    return tooltip;
  }

  initStickyAddToCart() {
    const submitContainer = this.querySelector('.tps-product-new-form__submit-container');
    if (!submitContainer) return;

    const stickyHeaderOffset = 100;
    const stickyBottomOffset = 80;
    let hasBeenVisible = false;
    let lastScrollY = window.pageYOffset || window.scrollY || 0;
    let isTicking = false;

    const cleanupStickyState = () => {
      submitContainer.classList.remove('is-sticky');
      if (this.stickyTracker) {
        this.stickyTracker.style.height = '1px';
      }
      const klaviyoTip = document.querySelector('[role="button"].needsclick');
      if (klaviyoTip) {
        klaviyoTip.style.display = 'block';
      }
    };

    const toggleSticky = (visible) => {
      submitContainer.classList.toggle('is-sticky', visible);

      if (!this.stickyTracker) return;
      if (visible) {
        this.stickyTracker.style.height = `${submitContainer.offsetHeight}px`;
      } else {
        this.stickyTracker.style.height = '1px';
      }

      const klaviyoTip = document.querySelector('[role="button"].needsclick');
      if (klaviyoTip) {
        klaviyoTip.style.display = visible ? 'none' : 'block';
      }
    };

    if (!this.stickyTracker) {
      this.stickyTracker = document.createElement('div');
      this.stickyTracker.className = 'tps-product-new-form__submit-tracker';
      this.stickyTracker.style.cssText = 'display:block; width:100%; height:1px; pointer-events:none;';
      submitContainer.parentNode.insertBefore(this.stickyTracker, submitContainer);
    }

    if (!this.stickySentinel) {
      this.stickySentinel = document.createElement('div');
      this.stickySentinel.className = 'tps-product-new-form__submit-sentinel';
      this.stickySentinel.style.cssText = 'display:block; width:100%; height:1px; pointer-events:none;';
      submitContainer.parentNode.insertBefore(this.stickySentinel, this.stickyTracker || submitContainer);
    }

    const startStickyObserver = () => {
      if (this.stickyObserver || !this.stickySentinel) return;
      lastScrollY = window.pageYOffset || window.scrollY || 0;

      const evaluateStickyState = (entry) => {
        const rect = entry ? entry.boundingClientRect : this.stickySentinel.getBoundingClientRect();
        const currentScrollY = window.pageYOffset || window.scrollY || 0;
        const isScrollingDown = currentScrollY > lastScrollY;
        lastScrollY = currentScrollY;

        const viewportBottomLimit = window.innerHeight - stickyBottomOffset;
        const isInsideVisibleRange = rect.bottom > stickyHeaderOffset && rect.top < viewportBottomLimit;
        if (isInsideVisibleRange) {
          hasBeenVisible = true;
        }

        const isFullyHiddenByTop = rect.bottom <= stickyHeaderOffset;
        const isFullyHiddenByBottom = rect.top >= viewportBottomLimit;
        const shouldSticky = hasBeenVisible && (
          (isFullyHiddenByTop && (isScrollingDown || submitContainer.classList.contains('is-sticky')))
          || (isFullyHiddenByBottom && (!isScrollingDown || submitContainer.classList.contains('is-sticky')))
        );
        toggleSticky(shouldSticky);
      };

      this.stickyObserver = new IntersectionObserver((entries) => {
        const entry = entries[0];
        if (!entry) return;
        evaluateStickyState(entry);
      }, {
        root: null,
        threshold: 0,
        rootMargin: `-${stickyHeaderOffset}px 0px -${stickyBottomOffset}px 0px`
      });

      this.stickyObserver.observe(this.stickySentinel);

      if (!this.stickyScrollHandler) {
        this.stickyScrollHandler = () => {
          if (isTicking || !this.stickySentinel) return;
          isTicking = true;
          window.requestAnimationFrame(() => {
            evaluateStickyState();
            isTicking = false;
          });
        };
      }
      window.addEventListener('scroll', this.stickyScrollHandler, { passive: true });

      if ('ResizeObserver' in window && !this.stickyResizeObserver) {
        this.stickyResizeObserver = new ResizeObserver(() => {
          if (submitContainer.classList.contains('is-sticky') && this.stickyTracker) {
            this.stickyTracker.style.height = `${submitContainer.offsetHeight}px`;
          }
          evaluateStickyState();
        });
        this.stickyResizeObserver.observe(submitContainer);
      }

      evaluateStickyState();
    };

    const stopStickyObserver = () => {
      if (this.stickyObserver) {
        this.stickyObserver.disconnect();
        this.stickyObserver = null;
      }
      if (this.stickyScrollHandler) {
        window.removeEventListener('scroll', this.stickyScrollHandler);
      }
      if (this.stickyResizeObserver) {
        this.stickyResizeObserver.disconnect();
        this.stickyResizeObserver = null;
      }
    };

    this.stickyMediaQuery = window.matchMedia('(max-width: 768px)');
    this.stickyMediaHandler = (e) => {
      if (e.matches) {
        startStickyObserver();
      } else {
        stopStickyObserver();
        hasBeenVisible = false;
        cleanupStickyState();
      }
    };

    if (this.stickyMediaQuery.addEventListener) {
      this.stickyMediaQuery.addEventListener('change', this.stickyMediaHandler);
    } else if (this.stickyMediaQuery.addListener) {
      this.stickyMediaQuery.addListener(this.stickyMediaHandler);
    }

    if (this.stickyMediaQuery.matches) {
      startStickyObserver();
    } else {
      cleanupStickyState();
    }
  }
  
  handleGallerySwitch(event) {
    const formContainer = this.querySelector('.tps-product-new__form');
    if (!formContainer) return;
    
    const productVariants = this.productVariants || [];
    const productOptions = productVariants[0] ? Object.keys(productVariants[0]).filter(key => key.startsWith('option')) : [];
    
    const changedCheckbox = event.target;
    const selectedValue = changedCheckbox.value;

    const tabElement = changedCheckbox.closest('.tps-product-new-form__tab');
    if (tabElement) {
      this.validateAllTabs();
    }


      const url = new window.URL(window.location.href);
      url.searchParams.delete('variant');
      window.history.replaceState({}, '', url.toString());
    
    let selectedVariantId = null;
    
    const matchedVariant = productVariants.find(variant => {
      const variantOptionValues = [];
      productOptions.forEach(opt => {
        const val = variant[opt];
        if (Array.isArray(val)) {
          variantOptionValues.push(...val);
        } else if (val) {
          variantOptionValues.push(val);
        }
      });
      
      return variantOptionValues.includes(selectedValue);
    });
    
    if (matchedVariant) {
      selectedVariantId = matchedVariant.id;
    }
    
    if (selectedVariantId) {
      this.switchToVariantImage(selectedVariantId);
    }
  }
  
  switchToVariantImage(variantId) {
    const slides = this.querySelectorAll('.tps-product__list');
    let targetIndex = -1;
    
    slides.forEach((slide, index) => {
      const slideVariantId = slide.dataset.variantId;
      if (targetIndex === -1 && slideVariantId && parseInt(slideVariantId) === parseInt(variantId)) {
        targetIndex = index;
      }
    });
    
    if (targetIndex === -1) {
      return;
    }
    
    if (this.SlideFlickity) {
      this.SlideFlickity.select(targetIndex, false, true);
      this.SlideFlickity.resize();
    }
  }
  
  
  validateAllTabs() {
    const maxSelections = Math.max(1, parseInt(this.dataset.maxSelections, 10) || 10);
    
    let totalSelected = 0;
    const allTabs = this.querySelectorAll('.tps-product-new-form__tab');
    allTabs.forEach(tab => {
      const checked = tab.querySelectorAll('.tps-product-new-form__option-input:checked');
      totalSelected += checked.length;
    });
    
    allTabs.forEach(tab => {
      const checkboxes = tab.querySelectorAll('.tps-product-new-form__option-input');
      
      if (totalSelected >= maxSelections) {
        checkboxes.forEach(checkbox => {
          if (!checkbox.checked) {
            checkbox.disabled = true;
            checkbox.closest('.tps-product-new-form__option').classList.add('tps-product-new-form__option--disabled');
          }
        });
      } else {
        checkboxes.forEach(checkbox => {
          checkbox.disabled = false;
          checkbox.closest('.tps-product-new-form__option').classList.remove('tps-product-new-form__option--disabled');
        });
      }
    });
  }


  updatePrice() {
    if (!this.priceElement || !this.form) return;

    const checkedOptions = this.form.querySelectorAll('.tps-product-new-form__option-input:checked');
    let totalPrice = 0;

    if (checkedOptions.length === 0) {
      totalPrice = this.initialPriceValue;
    } else {
      checkedOptions.forEach(option => {
        const variant = this.productVariants.find(v => v.title === option.value);
        if (variant) {
          totalPrice += variant.price;
        }
      });
    }
    
    const priceHtml = `<span class="money">${theme.Currency.formatMoney(totalPrice)}</span>`;
    this.priceElement.innerHTML = priceHtml;
    
    document.querySelectorAll('[data-product-price]').forEach(el => {
      if (el !== this.priceElement) {
        el.innerHTML = priceHtml;
      }
    });
  }

  updateSubmitButtonLabel() {
    if (!this.submitButton) return;

    const selectedCount = this.querySelectorAll('.tps-product-new-form__option-input:checked').length;
    const baseText = this.submitButtonBaseText || this.submitButton.textContent.trim() || 'ADD TO CART';

    this.submitButton.textContent = selectedCount > 0
      ? `${baseText} ×${selectedCount}`
      : baseText;
  }

  async tpsProductNewAddToCart(event) {
    event.preventDefault();
    
    const button = event.currentTarget || this.submitButton;
    if (!button || button.disabled) return;

    const productId = this.dataset.productId;
    
    const maxSelections = Math.max(1, parseInt(this.dataset.maxSelections, 10) || 10);
    const minSelections = Math.max(0, parseInt(this.dataset.minSelections, 10) || 1);
    const effectiveMinSelections = Math.min(minSelections, maxSelections);
    
    const buttonTooltip = this.querySelector('.tps-product-new-form__submit-container .tps-product-new__tooltip');
    const formTooltip = this.getFormTooltip();
    const showTooltip = (message, options = {}) => {
      const { nearForm = false } = options;
      const tooltip = nearForm ? (formTooltip || buttonTooltip) : buttonTooltip;
      if (!tooltip) return;
      tooltip.innerHTML = message;
      tooltip.style.display = 'block';
      if (nearForm) {
        const scrollTarget = this.querySelector('.tps-product-new-form__tab') || this.querySelector('.tps-product-new__form');
        if (scrollTarget) {
          const targetTop = scrollTarget.getBoundingClientRect().top + window.pageYOffset - 110;
          window.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });
        }
      } else {
        tooltip.scrollIntoView({ behavior: 'smooth', block: 'end' });
      }
    };

    this.querySelectorAll('.tps-product-new__tooltip').forEach((tip) => {
      tip.style.display = 'none';
    });

    const checkedOptions = Array.from(this.querySelectorAll('.tps-product-new-form__option-input:checked'));
    const totalSelected = checkedOptions.length;
    
    if (totalSelected < effectiveMinSelections) {
      showTooltip(`Please select at least ${effectiveMinSelections} option${effectiveMinSelections > 1 ? 's' : ''} (maximum ${maxSelections}).`, { nearForm: true });
      return;
    }
    
    if (totalSelected > maxSelections) {
      showTooltip(`Please select no more than ${maxSelections} option${maxSelections > 1 ? 's' : ''} (minimum ${effectiveMinSelections}).`, { nearForm: true });
      return;
    }

    const isBookletProduct = this.dataset.productHandle === 'choose-any-fabric-booklets';
    
    button.disabled = true;
    button.classList.add('tps-loading-btn');
    
    const productVariants = window.productVariants || [];
    const optionKeys = productVariants[0] ? Object.keys(productVariants[0]).filter((key) => key.startsWith('option')) : [];
    const valueToVariantId = new Map();

    productVariants.forEach((variant) => {
      optionKeys.forEach((optionKey) => {
        const optionValue = variant[optionKey];
        if (optionValue && !valueToVariantId.has(optionValue)) {
          valueToVariantId.set(optionValue, variant.id);
        }
      });
    });

    const itemsToAdd = checkedOptions.map((checkbox) => ({
      'id': valueToVariantId.get(checkbox.value) || productId,
      'quantity': 1,
    }));
    
    try {
      const formData = {
        'items': itemsToAdd,
        'sections': 'cart-items-num'
      };
      
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      if (!response.ok) {
        throw new Error('Cart update failed');
      }

      const data = await response.json();

      if (data.sections && data.sections['cart-items-num']) {
        const html = data.sections['cart-items-num'];
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const content = doc.querySelector('.cart-items-num');
        const cartItemsNum = document.querySelector('header#SiteHeader .cart-link .cart-items-num');
        if (content && cartItemsNum) {
          cartItemsNum.outerHTML = content.outerHTML;
        }
        if (window.theme && window.theme.tps && window.theme.tps.templateName == 'cart') {
          const cartPageItemsNum = document.querySelector('.tps-cart-page .cart-items-num');
          if (content && cartPageItemsNum) {
            cartPageItemsNum.outerHTML = content.outerHTML;
          }
        }
      }
      
      document.dispatchEvent(new CustomEvent('cart:open'));
      document.dispatchEvent(new CustomEvent('cart:build'));

      if (isBookletProduct) {
        this.lockBookletAddToCart();
      }
      
    } catch (error) {
      console.error('Error:', error);
      alert('Failed to add to cart. Please try again.');
    } finally {
      if (!isBookletProduct) {
        button.disabled = false;
      }
      button.classList.remove('tps-loading-btn');
    }
  }
  
  disconnectedCallback() {
    if (this.stickyMediaQuery && this.stickyMediaHandler) {
      if (this.stickyMediaQuery.removeEventListener) {
        this.stickyMediaQuery.removeEventListener('change', this.stickyMediaHandler);
      } else if (this.stickyMediaQuery.removeListener) {
        this.stickyMediaQuery.removeListener(this.stickyMediaHandler);
      }
      this.stickyMediaQuery = null;
      this.stickyMediaHandler = null;
    }
    if (this.stickyObserver) {
      this.stickyObserver.disconnect();
      this.stickyObserver = null;
    }
    if (this.stickyScrollHandler) {
      window.removeEventListener('scroll', this.stickyScrollHandler);
      this.stickyScrollHandler = null;
    }
    if (this.stickyResizeObserver) {
      this.stickyResizeObserver.disconnect();
      this.stickyResizeObserver = null;
    }
    if (this.stickyTracker) {
      this.stickyTracker.remove();
      this.stickyTracker = null;
    }
    if (this.stickySentinel) {
      this.stickySentinel.remove();
      this.stickySentinel = null;
    }
    if (this.SlideFlickity) {
      this.SlideFlickity.destroy();
    }
  }
}

customElements.define('tps-product-new', TpsProductNew);
